<app-modal-window title="Детальная информация"
                  [actions]="false"
                  (close)="close()">
  <div class="details-content">
    <div class="data" *ngIf="(element.data | keyvalue)?.length">
      <p>Data:</p>
      <pre>{{element.data | json}}</pre>
    </div>
    <div class="items" *ngIf="element.items">
      <p>Items:</p>
      <pre>{{element.items | json}}</pre>
    </div>
  </div>
</app-modal-window>
